import './App.css';
import { useState } from 'react';

const SECTIONS = [
  { id: 'macro-regime', title: 'Macro Regime' },
  { id: 'liquidity-engine', title: 'Liquidity' },
  { id: 'fiscal-dominance', title: 'Fiscal Dominance Monitor' },
  { id: 'volatility-regime', title: 'Volatility & Correlation' },
  { id: 'dollar-stress', title: 'Dollar Stress' },
] as const;

type SectionId = (typeof SECTIONS)[number]['id'];

function Macro(): React.JSX.Element {
  const [selectedId, setSelectedId] = useState<SectionId>(SECTIONS[0].id);
  const selectedSection = SECTIONS.find((s) => s.id === selectedId)!;

  return (
    <div className="App blog-page-static">
      <section className="blog-page blog-page-detail">
        <article className="blog-post-detail macro-dashboard">
          <h1 className="blog-post-detail-title" style={{ textAlign: 'center' }}>Macroeconomic Dashboard</h1>
          <nav className="macro-nav" aria-label="Dashboard sections">
            {SECTIONS.map(({ id, title }) => (
              <button
                key={id}
                type="button"
                className={`macro-nav-btn ${selectedId === id ? 'macro-nav-btn-active' : ''}`}
                onClick={() => setSelectedId(id)}
              >
                {title}
              </button>
            ))}
          </nav>
          <div key={selectedSection.id} id={selectedSection.id} className="macro-dashboard-content">
            <div className="macro-section-charts">
              <p className="macro-section-placeholder">Charts and metrics will go here.</p>
            </div>
          </div>
        </article>
      </section>
    </div>
  );
}

export default Macro;
